import { Bell, LogIn, LogOut, User } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { config } from "@/lib/config";
import { getActiveAccount, login, logout } from "@/auth/msal";

export function Header() {
  const authEnabled = config.isAuthEnabled();
  const account = authEnabled ? getActiveAccount() : null;
  const displayName = account?.name ?? account?.username ?? (authEnabled ? "Sign in" : "Dev");

  return (
    <header className="flex h-12 items-center gap-3 border-b border-border bg-card/80 px-4 backdrop-blur-sm">
      <div className="text-sm font-semibold text-foreground lg:hidden">Caldera</div>
      <div className="ml-auto flex items-center gap-1">
        <Button size="icon" variant="ghost" aria-label="Notifications" className="h-8 w-8">
          <Bell className="h-4 w-4" strokeWidth={1.5} />
        </Button>
        <div className="hidden items-center gap-1.5 rounded-md bg-surface px-2.5 py-1 text-[13px] md:flex">
          <User className="h-3.5 w-3.5 text-muted-foreground" strokeWidth={1.5} />
          <span>{displayName}</span>
        </div>
        {authEnabled ? (
          account ? (
            <Button size="sm" variant="ghost" onClick={() => void logout()}>
              <LogOut className="h-3.5 w-3.5" strokeWidth={1.5} />
              Sign out
            </Button>
          ) : (
            <Button size="sm" onClick={() => void login()}>
              <LogIn className="h-3.5 w-3.5" strokeWidth={1.5} />
              Sign in
            </Button>
          )
        ) : (
          <span className="rounded-md bg-surface px-2 py-0.5 text-2xs text-muted-foreground">
            Dev
          </span>
        )}
      </div>
    </header>
  );
}
